var _rect, _rect2, _path, _circle, _path2, _path3, _path4, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 50,
    viewBox: "0 0 58 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 48,
    rx: 7,
    fill: "white",
    stroke: "#2A5C96",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 32,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#2A5C96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0503 37.9913L11 37.0002L10.0464 37.9913L11.5735 39.4779C11.705 39.6145 11.8777 39.6832 12.0503 39.6832C12.223 39.6832 12.3956 39.6145 12.5271 39.4779L15.9536 35.9911L15 35L12.0503 37.9913Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 28,
    cy: 12,
    r: 5,
    fill: "#5883C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 18C24.6913 18 22 15.3086 22 12C22 8.69133 24.6914 6 28 6C31.3087 6 34 8.69135 34 12C34 15.3087 31.3082 18 28 18ZM28 7.99995C25.7944 7.99995 24 9.7944 24 12C24 14.2055 25.7944 16.0002 28 16.0002C30.2056 16.0002 32.0002 14.2055 32.0002 12C31.9998 9.7944 30.2051 7.99995 28 7.99995Z",
    fill: "#2A5C96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M18.9093 27H37.0921C37.5938 27 38.0008 26.6277 38 26.1667C38 21.1115 33.5139 17 28 17C22.4863 17 18 21.1115 18 26.1667C18 26.6269 18.4074 27 18.9093 27Z",
    fill: "#5883C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0013 28H18.0002C17.4481 28 17 27.5523 17 27C17 20.9338 21.9349 16 28 16C34.0653 16 39 20.9338 39 27C39.0009 27.5532 38.5532 28 38.0013 28H38.0013ZM19.0559 26.0011H36.9454C36.4464 21.5068 32.6254 18.001 28.0013 18.001C23.3761 18.0002 19.5544 21.5068 19.0559 26.0011Z",
    fill: "#2A5C96"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 35,
    x2: 46,
    y2: 35,
    stroke: "#2A5C96",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 39,
    x2: 39,
    y2: 39,
    stroke: "#2A5C96",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4c861629b0b3a5cfdd3f472478e122f1.svg";
export { ForwardRef as ReactComponent };